export default __webpack_public_path__ + "static/media/warn.92fb8fb5.svg";